import {Component, OnInit, Input} from '@angular/core';
import {UntypedFormGroup, UntypedFormControl} from '@angular/forms';
import {Equipment} from '@app/shared/models/equipment.model';
import {PartNumber} from '@app/shared/models/partNumber.model';
import {Log} from 'ng2-logger';

@Component({
    selector: 'app-part-number-equipment-form',
    templateUrl: './part-number-equipment-form.component.html',
    styleUrls: ['./part-number-equipment-form.component.scss']
})
export class PartNumberEquipmentFormComponent implements OnInit {
    _logger = Log.create(PartNumberEquipmentFormComponent.name);

    @Input() equipments: Equipment[] = [];
    @Input() showValidations;
    @Input() mode: string

    isLoading: boolean;

    get isFormValid() {
        return this.equipmentForm.valid;
    }

    public equipmentForm: UntypedFormGroup;
    public partNumber: PartNumber;

    constructor() {
    }

    ngOnInit() {
        this.equipmentForm = new UntypedFormGroup({
            'equipment': new UntypedFormControl([]),
        });
    }

    public init(partNumber: PartNumber) {
        if (partNumber) {
            this.partNumber = partNumber;
        }
    }

    public getFormDetails() {
        const formData = this.equipmentForm.getRawValue();
        return formData;
    }

    public resetForm() {
        this._logger.info("resetForm:: Resetting part number details form", this.partNumber);
        this.equipmentForm.reset();
    }

    public setForm(equipment: {equipment: Equipment[]}) {
        this.equipmentForm.setValue(equipment);
    }

    public isReadOnly() {
        return this.mode === 'view';
    }
}
